export default __webpack_public_path__ + "static/media/err-muh-gerd.d576196b.gif";